import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import { DataAPI } from 'services/DataService.jsx';

import Select from 'react-select';
import 'react-select/dist/react-select.css';
import * as Datetime from 'react-datetime';
import { FeatureFlags } from 'services/FeatureFlagsService.jsx'
// import noUiSlider from "nouislider";
// import wNumb from "wnumb";
import moment from 'moment-timezone';
// import TagsInput from 'react-tagsinput';

// import SweetAlert from 'react-bootstrap-sweetalert';

import NotificationSystem from 'react-notification-system';
import { style } from "variables/Variables.jsx";

// import C3Chart from 'react-c3js';
import QuickC3 from 'components/QuickC3/QuickC3.jsx'
import 'c3/c3.css';

import Log from 'services/Log.jsx'



var dateFormat = require('dateformat');

let startDate = new Date(Date.now() - 1000 * 60 * 60);
// let startDate = new Date();
let endDate = new Date();

let metrics = [];
let clients = [];
// let tags = [];

let shouldUpdateChart = false;

// let timeSlider;
// let resolutionSlider;

// const c3data = {
//     columns: [
//         ['data1', 30, 200, 100, 400, 150, 250],
//         ['data2', 50, 20, 10, 40, 15, 25]
//     ]
// };

const relativeFrameOptions = [
    {id: 0, label: "15 minutes"},
    {id: 1, label: "30 minutes"},
    {id: 2, label: "1 Hour"},
    {id: 3, label: "8 Hours"},
    {id: 4, label: "1 Day"},
    {id: 5, label: "1 Week"},
    {id: 6, label: "2 Weeks"},
    {id: 7, label: "1 Month"}
];

const resolutions = [
  {id: 0, label: "1 Millisecond"},
  {id: 1, label: "1 Second"},
  {id: 2, label: "1 Minute"},
  {id: 3, label: "15 Minutes"},
  {id: 4, label: "1 Hour"},
  {id: 5, label: "1 Day"}
]

const aggregations = [
  {id: 0, label: "None"},
  {id: 1, label: "Sum"},
  {id: 2, label: "Average"},
  {id: 3, label: "Count"},
  {id: 4, label: "Min"},
  {id: 5, label: "Max"}
]

const downsamplers = [
  {id: 0, label: "None"},
  {id: 1, label: "Sum"},
  {id: 2, label: "Average"},
  {id: 3, label: "Count"},
  {id: 4, label: "Min"},
  {id: 5, label: "Max"}
]

let metricTags = [];
let tagKeys = [];
let tagValues = [];

let queryDetails = [];
// {'level': 'warning', 'message': 'wat'}

const dataset_template = {
    label: 'My First dataset',
    fill: false,
    lineTension: 0.1,
    backgroundColor: 'rgba(75,192,192,0.4)',
    borderColor: 'rgba(75,192,192,1)',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0.0,
    borderJoinStyle: 'miter',
    pointBorderColor: 'rgba(75,192,192,1)',
    pointBackgroundColor: '#fff',
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
    pointHoverBorderColor: 'rgba(220,220,220,1)',
    pointHoverBorderWidth: 2,
    pointRadius: 1,
    pointHitRadius: 10,
    data: [65, 59, 80, 81, 56, 55, 40]
};

class Explorer extends Component{

    c3formating(x) {
        // Log.debug("[c3Formating]: " + JSON.stringify(this.state));
        if (this.state.sliderResolutionNumeric <= 1)
            return dateFormat(x, "yyyy-mm-dd HH:MM:ss");
        else if (this.state.sliderResolutionNumeric === 2) {
            return dateFormat(x, "yyyy-mm-dd HH:MM");
        }
        return dateFormat(x, "yyyy-mm-dd HH:MM:ss");
    }

    c3formatingAlt(x) {
        // Log.debug("[c3Formating]: " + JSON.stringify(this.state));
        if (this.state.sliderResolutionNumeric <= 1)
            return dateFormat(x, "yyyy-mm-dd HH:MM:ss.l");
        else if (this.state.sliderResolutionNumeric === 2) {
            return dateFormat(x, "yyyy-mm-dd HH:MM:ss");
        }
        return dateFormat(x, "yyyy-mm-dd HH:MM:ss");
    }

    constructor() {
        super();
        this.state = {
            _notificationSystem: null,
            timeframe: 1,
            relativeFrame: relativeFrameOptions[0],
            selectedMetric: "",
            selectedClient: "",
            selectedResolution: 2,
            maxTimespan: this.getMaxTimespan(2),
            selectedAggregation: 1,
            selectedDownsampler: 1,
            selectedTagKey: "",
            selectedTagValue: "",
            queryRunning: false,
            metricsLoading: false,
            clientsLoading: false,
            tagKeyLoading: false,
            tagValueLoading: false,
            dateUpdated: true,
            alert: null,
            selectedTag: "",
            metricTags: [],
            sliderDuration: "5 min",
            sliderResolution: "Raw",
            sliderResolutionNumeric: 0,
            aggregation: 0,
            shouldRedraw: false,
            highRes: true,
            startDate:new Date(Date.now() - 1000 * 60 * 60),
            endDate:new Date(),
            c3: {
                unload: true,
                x: 'x',
                columns: [['x']],

            },
            c3axis: {
                x: {
                    type: 'timeseries',
                    tick: {
                        format: this.c3formating.bind(this),
                        culling: {
                            max: 5
                        }
                    }
                }
            },
            c3tooltip: {
                format: {
                    title: this.c3formatingAlt.bind(this)
                }
            },
            chart_options: {
                fill: false,
                    responsive: true,
                    scales: {
                    xAxes: [{
                        type: 'time',
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: "Date/Time",
                        }
                    }],
                        yAxes: [{
                        ticks: {
                            beginAtZero: true,
                        },
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: "Value",
                        }
                    }]
                }
            },
            chart_data : {
                labels: [],
                datasets: [
                    {
                        label: 'New Query',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'rgba(75,192,192,0.4)',
                        borderColor: 'rgba(75,192,192,1)',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'rgba(75,192,192,1)',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 1,
                        pointHoverRadius: 5,
                        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                        pointHoverBorderColor: 'rgba(220,220,220,1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: []
                    }
                ]
            }
        };
        this.handleMetricTags = this.handleMetricTags.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.editFilters = this.editFilters.bind(this);
        this.showQueryDetails = this.showQueryDetails.bind(this);
        this.updateQuery();
    }

    getResolutions() {
      return resolutions.filter((resolution) => {
        if (FeatureFlags.isEnabled(FeatureFlags.FLAGS.MILLISECOND_RESOLUTION)) {
          return resolution.id >=0;
        } else if (FeatureFlags.isEnabled(FeatureFlags.FLAGS.SECOND_RESOLUTION)) {
          return resolution.id >=1;
        } else {
          return resolution.id >= 2;
        }
      });
    }

    getDownSamplers() {
      if (this.state.selectedResolution === 0) {
        return downsamplers;
      } else {
        return downsamplers.filter((sampler) => {
          return sampler.id > 0;
        });
      }
    }

    getAggregations() {
      if (this.state.selectedTagKey !== "") {
        return aggregations;
      } else {
        return aggregations.filter((sampler) => {
          return sampler.id > 0;
        });
      }
    }

    showQueryDetails() {
      var position = 'tc';
      queryDetails.forEach((detail) => {
        var dismiss = 10;
        var title = (<span data-notify="icon" className="pe-7s-gift"></span>);
        if (this.state._notificationSystem) {
          if (detail.dismiss) {
            dismiss = 3;
          }
          if (detail.level !== "success") {
            title = (<span data-notify="icon" className="pe-7s-attention"></span>)
          }

            this.state._notificationSystem.addNotification({
                title: title,
                message: (
                    <div>
                        {detail.message}
                    </div>
                ),
                level: detail.level,
                position: position,
                autoDismiss: dismiss
            });
        }
      });
      queryDetails = [];
    }
    hideAlert(){
        this.setState({
            alert: null
        });
    }
    updateQuery(mcFilter) {
      mcFilter = {"metric": "", "client": ""} || mcFilter;
      this.updateClients(mcFilter["metric"]);
      this.updateMetrics(mcFilter["client"]);
    }
    updateClients(metric) {
      this.setState({clientsLoading: true});
      var currentClient = this.state.selectedClient;
      var newSelectedClient = "";
      var formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      // var durationStr = timeSlider.noUiSlider.get();
      // var duration = parseInt(durationStr.split(' ')[0], 10);
      // var localEndDate = moment(startDate).add(duration, 'm').toDate();
      var localEndDate = moment(startDate).toDate();
      var formatedEndDate = dateFormat(this.convertDateToUTC(localEndDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      formatedEndDate = dateFormat(this.convertDateToUTC(endDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      Log.debug("[relFrame] start: " + formatedStartDate);
      Log.debug("[relFrame] end: " + formatedEndDate);

      Log.debug("[loadDate] " + formatedStartDate);
      Log.debug("[selectedMetric] " + this.state.selectedMetric);
      DataAPI.getClients({
          start_date: formatedStartDate,
          end_date: formatedEndDate,
          metric_id: metric,
      }, (response) => {
          Log.debug(JSON.stringify(response));
          if (response.success) {
              var new_clients = [];
              response.data.clients.forEach((client) => {
                  new_clients.push({"name": client.name, "id": client.id});
                  if (client.id === currentClient) {
                    newSelectedClient = currentClient;
                  }
              });
              clients = new_clients;
          } else {
              clients = [];
          }
          Log.debug("resetting selectedClient");
          // this.updateMetrics();
          this.setState({
              selectedClient: newSelectedClient,
              clientsLoading: false
          }, this.updateTags);
      });
    }
    updateMetrics(client) {
      this.setState({metricsLoading: true});
      var currentMetric = this.state.selectedMetric;
      var newSelectedMetric = "";
      var formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      // var durationStr = timeSlider.noUiSlider.get();
      // var duration = parseInt(durationStr.split(' ')[0], 10);
      var localEndDate = moment(startDate).toDate();
      var formatedEndDate = dateFormat(this.convertDateToUTC(localEndDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      formatedEndDate = dateFormat(this.convertDateToUTC(endDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      Log.debug("[relFrame] start: " + formatedStartDate);
      Log.debug("[relFrame] end: " + formatedEndDate);
      Log.debug("[loadDate] " + formatedStartDate);
      DataAPI.getMetrics({
          start_date: formatedStartDate,
          client_id: client,
          end_date: formatedEndDate
      }, (response) => {
          Log.debug(JSON.stringify(response));
          if (response.success) {
              metrics = response.data.metrics;
          } else {
              metrics = [];
          }
          if (metrics.filter(e => e.id === currentMetric).length > 0) {
            newSelectedMetric = currentMetric;
          }
          Log.debug("resetting selectedMetric");
          this.setState({
              selectedMetric: newSelectedMetric,
              metricsLoading: false
          }, this.updateTags);
      });
    }

    updateTagKeys() {
      var currentClient = this.state.selectedClient;
      var currentMetric = this.state.selectedMetric;
      var currentTagKey = this.state.selectedTagKey;
      var newSelectedTag = "";
      if (currentClient === "" && currentMetric === "") {
        return;
      }
      this.setState({tagKeyLoading: true});
      var formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      var localEndDate = moment(startDate).toDate();
      var formatedEndDate = dateFormat(this.convertDateToUTC(localEndDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      formatedEndDate = dateFormat(this.convertDateToUTC(endDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      Log.debug("[relFrame] start: " + formatedStartDate);
      Log.debug("[relFrame] end: " + formatedEndDate);
      Log.debug("[loadDate] " + formatedStartDate);
      DataAPI.getTags({
          type: 0,
          start_date: formatedStartDate,
          metric_id: currentMetric,
          client_id: currentClient,
          end_date: formatedEndDate
      }, (response) => {
          Log.debug(JSON.stringify(response));
          if (response.success) {
              tagKeys = response.data.tags;
          } else {
              tagKeys = [];
          }
          if (tagKeys.filter(e => e.id === currentTagKey).length > 0) {
            newSelectedTag = currentTagKey;
          }
          Log.debug("resetting selectedTag");
          // Log.debug("tags: ", response.data.tags);
          Log.debug("CTK", currentTagKey);
          Log.debug("nst", newSelectedTag);
          this.setState({
            selectedTagKey: newSelectedTag,
            tagKeyLoading: false
          }, this.updateTagValues.bind(this, newSelectedTag));
      });
    }

    updateTagValues(selectedTag) {
      var currentClient = this.state.selectedClient;
      var currentMetric = this.state.selectedMetric;
      var currentTagValue = this.state.selectedTagValue;
      var newSelectedTag = "";
      if (selectedTag === "") {
        // console.log("no tag key");
        this.setState({selectedTagValue: ""});
        return;
      }
      if (currentClient === "" && currentMetric === "") {
        // console.log("no cid or mid");
        return;
      }
      this.setState({tagValueLoading: true});
      var formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      var localEndDate = moment(startDate).toDate();
      var formatedEndDate = dateFormat(this.convertDateToUTC(localEndDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      formatedEndDate = dateFormat(this.convertDateToUTC(endDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
      Log.debug("[relFrame] start: " + formatedStartDate);
      Log.debug("[relFrame] end: " + formatedEndDate);
      Log.debug("[loadDate] " + formatedStartDate);
      DataAPI.getTags({
          type: 1,
          start_date: formatedStartDate,
          metric_id: currentMetric,
          client_id: currentClient,
          tag_key: selectedTag,
          end_date: formatedEndDate
      }, (response) => {
          Log.debug(JSON.stringify(response));
          if (response.success) {
              tagValues = response.data.tags;
          } else {
              tagValues = [];
          }
          if (tagValues.filter(e => e.id === currentTagValue).length > 0) {
            newSelectedTag = currentTagValue;
          }
          Log.debug("resetting selectedTag");
          this.setState({
            selectedTagValue: newSelectedTag,
            tagValueLoading: false
          });
      });
    }

    updateTags() {
      this.updateTagKeys();
    }

    fetchQuery() {
      this.updateQuery();
    }
    handleStartDate(e) {
        startDate = e.toDate();
        endDate = this.capDate(startDate, endDate, this.state.selectedResolution);
        this.setState({dateUpdated: true, endDate: endDate, startDate: startDate});
        this.updateQuery();
    }
    handleEndDate(e) {
        endDate = e.toDate();
        startDate = this.capDateInverse(startDate, endDate, this.state.selectedResolution);
        this.setState({dateUpdated: true, endDate: endDate, startDate: startDate});
        this.updateQuery();
    }
    handleStartDateChange(e) {
      startDate = e.toDate();
      this.setState({startDate: startDate});
    }
    handleEndDateChange(e) {
      endDate = e.toDate();
      this.setState({endDate: endDate});
    }
    handleSwitch(e, state) {
        this.setState({highRes: state});
        // this.updateQuery();
    }
    setRelativeTimeframe() {
        Log.debug("[Explorer] timeframe: 0");
        this.setState({
            timeframe: 0
        });
    }

    selectMetric(value) {
      var sMetric = (value == null ? "" : value.id);
      this.setState({ selectedMetric: sMetric, selectedTag: ""});
      if (this.state.selectedClient == "" || sMetric == "") {
        this.updateClients(sMetric);
        if (sMetric == "") {
          this.clearTags();
        }
      } else {
        this.updateTags();
      }
    }

    clearTags() {
      Log.debug("clear tags");
      tagKeys = [];
      tagValues = [];
      this.setState({selectedTagKey: "", selectedTagValue: ""});
    }

    selectTagKey(value) {
      var sMetric = (value == null ? "" : value.id);
      var newState = { selectedTagKey: sMetric}
      if (sMetric == "" && this.state.selectedAggregation == 0) {
        newState['selectedAggregation'] = 1;
      }
      this.setState(newState);
      this.updateTagValues(sMetric);
    }

    selectTagValue(value) {
      var sMetric = (value == null ? "" : value.id);
      this.setState({ selectedTagValue: sMetric});
    }

    selectClient(value) {
      var sMetric = (value == null ? "" : value.id);
      this.setState({ selectedClient: sMetric});
      if (this.state.selectedMetric == "" || sMetric == "") {
        this.updateMetrics(sMetric);
      } else {
        this.updateTags();
      }
    }



    setAbsoluteTimeframe() {
        Log.debug("[Explorer] timeframe: 1");
        this.setState({
            timeframe: 1
        });
    }
    convertDateToUTC(date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

    handleMetricTags(filledTags) {
      // console.log(filledTags);
      metricTags = filledTags;
        this.setState({metricTags: filledTags});
    }

    getRelativeStartDate() {
      if (!this.state.relativeFrame) {
        Log.debug("invalid rf");
        return false;
      }
      Log.debug("[relFrame] " + JSON.stringify(this.state.relativeFrame));
      var duration = 0;
      var unit = 0;
      if (this.state.relativeFrame.id === 0) {
          duration = 15;
      } else if (this.state.relativeFrame.id === 1) {
          duration = 30;
      } else if (this.state.relativeFrame.id === 2) {
          duration = 1;
          unit = 1;
      } else if (this.state.relativeFrame.id === 3) {
          duration = 8;
          unit = 1;
      } else if (this.state.relativeFrame.id === 4) {
          duration = 1;
          unit = 2;
      } else if (this.state.relativeFrame.id === 5) {
          duration = 7;
          unit = 2;
      } else if (this.state.relativeFrame.id === 6) {
          duration = 15;
          unit = 2;
      } else if (this.state.relativeFrame.id === 7) {
          duration = 1;
          unit = 3;
      }
      endDate = new Date();
      var momentStartDate = moment(new Date());
      Log.debug("unit", unit, "duration", duration);
      if (unit === 0) {
          momentStartDate = momentStartDate.subtract(duration, "minutes");
      } else if (unit === 1) {
          momentStartDate = momentStartDate.subtract(duration, "hours");
      } else if (unit === 2) {
          momentStartDate = momentStartDate.subtract(duration, "days");
      } else if (unit === 3) {
          momentStartDate = momentStartDate.subtract(duration, "months");
      }
      startDate = momentStartDate.toDate();
      return true;
    }

    editFilters() {
      // console.log(this.state);
      // if (this.state.dateUpdated) {
      //   this.updateQuery();
      // }
      // this.setState({
      //       dateUpdated: false,
      //       alert: (
      //           <SweetAlert
      //               style={{display: "block",marginTop: "-100px"}}
      //               title="Edit filters"
      //               onConfirm={(e) => this.hideAlert(e)}
      //               confirmBtnBsStyle="info"
      //           >
      //           <Select
      //               placeholder="Metric"
      //               name="metric"
      //               value={this.state.selectedMetric}
      //               valueKey={"id"}
      //               labelKey={"name"}
      //               clearable={false}
      //               options={metrics}
      //               onChange={(value) => {
      //                     this.setState({ selectedMetric: (value == null ? "" : value.id)}, this.props.handleSelect);
      //                   }
      //                 }
      //           />
      //           //select metric
      //           //select client
      //           //clarification
      //         </SweetAlert>
      //       )
      //   });
    }

    getMaxTimespan(id) {
      if (id == 0) {
        return " 5 minutes";
      } else if (id == 1) {
        return " 1 hour";
      } else if (id == 2) {
        return " 15 days";
      } else if (id == 3) {
        return " 2 months";
      } else if (id == 4) {
        return " 1 year";
      } else if (id == 5) {
        return " 2 years";
      } else {
        return " 5 minutes";
      }
    }

    handleC3Rendered() {
      shouldUpdateChart = false;
    }

    runQuery() {
      this.setState({queryRunning: true}, this.runQueryDeep);
    }

    addQueryDetail(level, message, dismissable = false) {
      queryDetails.push({level: level, message: message, dismiss: dismissable});
    }

    capDateInverse(startDate, endDate, resolution) {
      var startTime = startDate.getTime();
      var endTime = endDate.getTime();
      var diff = endTime - startTime;
      var newStartDate = startDate;
      var threshold = 0;
      if (resolution == 0) {
        threshold = 1000 * 60 * 5;
      } else if (resolution == 1) {
        threshold = 1000 * 60 * 60;
      } else if (resolution == 2) {
        threshold = 1000 * 60 * 60 * 24 * 15;
      } else if (resolution == 3) {
        threshold = 1000 * 60 * 60 * 24 * 60;
      } else if (resolution == 4) {
        threshold = 1000 * 60 * 60 * 24 * 365;
      } else if (resolution == 5) {
        threshold = 1000 * 60 * 60 * 24 * 365 * 2;
      } else {
        threshold = 1000 * 60 * 5;
      }
      if (threshold > 0) {
        if (diff < 0 || (diff > threshold)) {
          newStartDate = new Date(endDate.getTime() - threshold);
        }
      }
      return newStartDate;
    }

    capDate(startDate, endDate, resolution) {
      var startTime = startDate.getTime();
      var endTime = endDate.getTime();
      var diff = endTime - startTime;
      var newEndDate = endDate;
      var threshold = 0;
      if (resolution == 0) {
        threshold = 1000 * 60 * 5;
      } else if (resolution == 1) {
        threshold = 1000 * 60 * 60;
      } else if (resolution == 2) {
        threshold = 1000 * 60 * 60 * 24 * 15;
      } else if (resolution == 3) {
        threshold = 1000 * 60 * 60 * 24 * 60;
      } else if (resolution == 4) {
        threshold = 1000 * 60 * 60 * 24 * 365;
      } else if (resolution == 5) {
        threshold = 1000 * 60 * 60 * 24 * 365 * 2;
      } else {
        threshold = 1000 * 60 * 5;
      }
      if (threshold > 0) {
        if (diff < 0 || (diff > threshold)) {
          newEndDate = new Date(startDate.getTime() + threshold);
        }
      }
      return newEndDate;
    }

    runQueryDeep() {
        Log.debug("[Explorer] runQuery");
        var formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
        var formatedEndDate = dateFormat(this.convertDateToUTC(endDate), "yyyy-mm-dd HH:MM:ss") + ".000";
        formatedEndDate = dateFormat(this.convertDateToUTC(this.capDate(startDate, endDate, this.state.selectedResolution)), "yyyy-mm-dd HH:MM:ss") + ".000";
        formatedStartDate = dateFormat(this.convertDateToUTC(startDate), "yyyy-mm-dd HH:MM:ss") + ".000";
        Log.debug("start: " + formatedStartDate);
        Log.debug("end: " + formatedEndDate);
        var metric = metrics.find((metric) => {
           return metric.id === this.state.selectedMetric;
        });
        if (!metric) {
          this.addQueryDetail('error', 'Metric must be set to run a query');
          this.setState({queryRunning: false}, this.showQueryDetails);
          return;
        }
        if (this.state.selectedTagKey.length > 0 && (this.state.selectedTagValue == null || this.state.selectedTagValue.length == 0)) {
          this.addQueryDetail('error', 'Tag Value must be set when Tag Key is set to run a query');
          this.setState({queryRunning: false}, this.showQueryDetails);
          return;
        }
        shouldUpdateChart = true;
        Log.debug("[metric_name] " + metric.name);

        Log.debug("[loadDate] " + formatedStartDate);
        var requestData = {
            start_date: formatedStartDate,
            end_date: formatedEndDate,
            client_id: this.state.selectedClient,
            tag_key: this.state.selectedTagKey,
            tag_val: this.state.selectedTagValue,
            metric_id: this.state.selectedMetric,
            resolution: this.state.selectedResolution,
            downsampler: this.state.selectedDownsampler,
            aggregation: this.state.selectedAggregation
        };
        DataAPI.getData(requestData, (response) => {
            Log.debug(JSON.stringify(response));
            if (response.success) {
                Log.debug("[DATA RECEIVED]");
                var new_chart_data = this.state.chart_data;
                var new_dataset = dataset_template;
                new_dataset.label = metric.name;
                var new_datapoints = [];
                var new_labels = [];
                response.data.datapoints.forEach((point) => {
                    new_datapoints.push(point.value);
                    new_labels.push(new Date(point.date));
                });
                new_dataset.data = new_datapoints;
                new_chart_data.labels = new_labels;
                new_chart_data.datasets = [new_dataset];



                Log.debug("c3 update");
                var new_c3 = this.state.c3;
                var new_c3_cols = [];
                var new_c3_x = ['x'];
                var new_c3_data = [metric.name];
                response.data.datapoints.forEach((point) => {
                    new_c3_data.push(point.value);
                    new_c3_x.push(new Date(point.date));
                });

                new_c3_cols.push(new_c3_x);
                new_c3_cols.push(new_c3_data);
                new_c3.columns = new_c3_cols;
                this.addQueryDetail('success', 'Query finished with ' + response.data.datapoints.length + ' results', true);
                this.setState({chart_data: new_chart_data, shouldRedraw: true, c3: new_c3, queryRunning: false}, this.showQueryDetails);
            } else {
                // metrics = [];
                Log.debug("clearing data");
                var new_c3 = this.state.c3;
                var new_c3_cols = [];
                var new_c3_x = ['x'];
                var new_c3_data = [];
                new_c3_cols.push(new_c3_x);
                new_c3_cols.push(new_c3_data);
                new_c3.columns = new_c3_cols;
                this.addQueryDetail('error', 'Query returned 0 results');
                this.setState({chart_data: [], shouldRedraw: true, c3: new_c3, queryRunning: false}, this.showQueryDetails);
            }
        });
    }

    handleResolutionSelection(value) {
      // console.log(value);
      if (value.id > 0 && this.state.selectedDownsampler === 0) {
        this.setState({ selectedResolution: (value == null ? 2 : value.id), selectedDownsampler: 1, maxTimespan: this.getMaxTimespan(value.id)});
      } else {
        this.setState({ selectedResolution: (value == null ? 2 : value.id), maxTimespan: this.getMaxTimespan(value.id)});
      }
    }

  componentDidMount(props) {
    this.setState({_notificationSystem: this.refs.notificationSystem});
    // timeSlider = document.getElementById('timeSlider');
  }
    render(){
        return (
            <div className="main-content">
              <NotificationSystem ref="notificationSystem" style={style}/>
              {this.state.alert}
                <Grid fluid>
                    <Row className="flex-equal-row">
                      <Col md={4} className={"flexit"}>
                        <Card
                            title="Data"
                            content={
                                <div className="explorer-query-view">
                                  <span className="date-label">Resolution: </span>
                                  <Select
                                      placeholder="Resolution"
                                      name="resolution"
                                      value={this.state.selectedResolution}
                                      valueKey={"id"}
                                      clearable={false}
                                      options={this.getResolutions()}
                                      onChange={(value) => {
                                            this.handleResolutionSelection(value)
                                          }
                                        }
                                  />
                                <span className="date-label">Downsampler: </span>
                                  <Select
                                      placeholder="Downsampler"
                                      name="downsampler"
                                      value={this.state.selectedDownsampler}
                                      valueKey={"id"}
                                      clearable={false}
                                      options={this.getDownSamplers()}
                                      onChange={(value) => {
                                            this.setState({ selectedDownsampler: (value == null ? 1 : value.id)})
                                          }
                                        }
                                  />
                                  <div className="date-picker-wrapper">
                                      <span className="date-label">From: </span>
                                      <Datetime onChange={this.handleStartDateChange.bind(this)} value={this.state.startDate} onBlur={this.handleStartDate.bind(this)}/>
                                  </div>
                                  <div className="date-picker-wrapper">
                                      <span className="date-label">To: </span>
                                      <Datetime onChange={this.handleEndDateChange.bind(this)} value={this.state.endDate} onBlur={this.handleEndDate.bind(this)}/>
                                  </div>
                                  <span className="date-label">Time range limited to {this.state.maxTimespan} based on the selected resolution</span>
                                </div>
                              }
                          />
                      </Col>
                      <Col md={3} className={"flexit"}>
                        <Card
                            title="Filters"
                            content={
                                <div className="explorer-query-view">
                                  <div>
                                    <span className="date-label">Metric: </span>
                                    <Select
                                        placeholder="Metric"
                                        name="metric"
                                        value={this.state.selectedMetric}
                                        valueKey={"id"}
                                        labelKey={"name"}
                                        options={metrics}
                                        isLoading={this.state.metricsLoading}
                                        onChange={(value) => this.selectMetric(value)}
                                    />
                                  </div>
                                  <div>
                                    <span className="date-label">Client: </span>
                                    <Select
                                        placeholder="Client"
                                        name="client"
                                        value={this.state.selectedClient}
                                        valueKey={"id"}
                                        labelKey={"name"}
                                        options={clients}
                                        isLoading={this.state.clientsLoading}
                                        onChange={(value) => this.selectClient(value)}
                                    />
                                  </div>
                                  <div>
                                    <span className="date-label">Tag Key: </span>
                                    <Select
                                        placeholder="Tag Key"
                                        name="tagkey"
                                        value={this.state.selectedTagKey}
                                        valueKey={"id"}
                                        labelKey={"name"}
                                        options={tagKeys}
                                        disabled={!FeatureFlags.isEnabled(FeatureFlags.FLAGS.DATA_TAGGING)}
                                        isLoading={this.state.tagKeyLoading}
                                        onChange={(value) => this.selectTagKey(value)}
                                    />
                                  </div>
                                  <div>
                                    <span className="date-label">Tag Value: </span>
                                    <Select
                                        placeholder="Tag Value"
                                        name="tagvalue"
                                        value={this.state.selectedTagValue}
                                        valueKey={"id"}
                                        labelKey={"name"}
                                        options={tagValues}
                                        disabled={!FeatureFlags.isEnabled(FeatureFlags.FLAGS.DATA_TAGGING)}
                                        isLoading={this.state.tagValueLoading}
                                        onChange={(value) => this.selectTagValue(value)}
                                    />
                                  </div>
                                  <div className="btn btn-success btn-fill run-query" onClick={this.fetchQuery.bind(this)}>Manual refresh</div>
                                </div>
                              }
                          />
                      </Col>
                      <Col md={3} className={"flexit"}>
                        <Card
                            title="Operations"
                            content={
                                <div className="explorer-query-view">
                                  <span className="date-label">Aggregation: </span>
                                  <Select
                                      placeholder="Aggregation"
                                      name="aggregation"
                                      value={this.state.selectedAggregation}
                                      valueKey={"id"}
                                      clearable={false}
                                      options={this.getAggregations()}
                                      onChange={(value) => {
                                            this.setState({ selectedAggregation: (value == null ? "" : value.id)})
                                          }
                                        }
                                  />
                                </div>
                                }
                        />
                      </Col>
                      <Col md={2} className={"flexit"}>
                        <Card
                          contentFullHeight={true}
                          noPadding={true}
                          content={
                            <div className={"h-100"}>
                              <div className="btn btn-success btn-fill run-query h-100 vertical-flex" onClick={this.runQuery.bind(this)} disabled={this.state.queryRunning}>
                                <span className={"w-100"}>Run</span>
                              </div>
                            </div>
                          }
                        />
                      </Col>
                    </Row>
                    <Row>

                    </Row>
                      <Row>
                        <Col md={12} className="flex-equal-col">
                            <Card
                                title="Data"
                                content={
                                    <div className="explorer-data-view">
                                        <QuickC3 shouldUpdate={shouldUpdateChart} data={this.state.c3} axis={this.state.c3axis} subchart={{show: true}} tooltip={this.state.c3tooltip} onRef={ref => (this.c3Chart = ref)} onrendered={this.handleC3Rendered}/>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default Explorer;



// WEBPACK FOOTER //
// ./src/views/Explorer/Explorer.jsx